import { defineMessages } from 'react-intl';
import { getDisplayInformation } from './get-display-information';
import { DataCache } from './data-cache';
import { CarrierEnums } from '../../enums/carriers';
import { getSanitizedName } from './name-utils';

export const messages = defineMessages({
  unknownCarrier: {
    description: 'dataDrivenLogos.unknownCarrier',
    defaultMessage: 'Unknown Carrier',
    id: 'gfa9Od',
  },
  otherCarrierName: {
    description: 'Other',
    defaultMessage: 'Other',
    id: 'EPmr0F',
  },
});

export const getCarrierDisplayName = (id, sanitizeBranding = false) => {
  const cache = DataCache.getCache() || {};
  const labelProviders = cache.labelProviders || [];

  const carrierIdValue = Number.parseInt(id, 10);
  // Walleted FedEx broke the paradigm of carrierId being the same as across multiple "provider implementations of the
  // same carrier. This overrides the carrierId for use-cases where the app is looking for the simplified carrier name
  const carrierId = `${carrierIdValue}` === `${CarrierEnums.FedExWalleted.carrierId}` ? CarrierEnums.FedEx.carrierId : carrierIdValue;

  if (carrierId === Number.parseInt(CarrierEnums.USPS.carrierId, 10)) {
    // Return inline message descriptor to avoid formatjs/no-useless-message lint error
    return { id: 'carrier.usps', defaultMessage: 'USPS' };
  }

  if (carrierId === 6) {
    return messages.otherCarrierName;
  }

  const amazonShippingCarrierIdInt = Number.parseInt(CarrierEnums.AmazonShipping.carrierId, 10);
  if (carrierId === amazonShippingCarrierIdInt) {
    const amazonShippingValue = labelProviders.find(
      (provider) =>
        provider.carrierId === amazonShippingCarrierIdInt || Number.parseInt(provider.carrierId, 10) === amazonShippingCarrierIdInt,
    );
    if (amazonShippingValue) {
      // Return inline message descriptor to avoid formatjs/no-useless-message lint error
      return { id: 'carrier.amazonShipping', defaultMessage: amazonShippingValue.name };
    }
  }

  const displayInformation = getDisplayInformation({ carrierId }) || {};
  let carrierName = displayInformation.name;
  if (!carrierName) {
    return messages.unknownCarrier;
  }

  if (sanitizeBranding) {
    carrierName = getSanitizedName(carrierName);
  }

  // Return inline message descriptor to avoid formatjs/no-useless-message lint error
  return { id: 'carrier.dynamic', defaultMessage: carrierName };
};
